<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.deviceId" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.deviceId" :key="item.deviceId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="点位编码"  v-if="type==0">
					<el-select v-model="filters.deviceId" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.deviceId" :key="item.deviceId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="time" type="daterange" :picker-options="pickerOptions" 	value-format="yyyy-MM-dd" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>
		
        <el-table :data="maintenanceRecordList" border highlight-current-row  size="mini" :height="formHeight">
            <el-table-column type="index" label="序号" ></el-table-column >
            <el-table-column prop="projectName" label="项目名称"    ></el-table-column>
			<el-table-column prop="siteName" label="点位名称"    ></el-table-column>

			<el-table-column prop="time" label="送检日期"> </el-table-column>
			<el-table-column prop="expiration" label="有效期至"></el-table-column>

            <el-table-column  label="送检证书" >
                <template slot-scope="scope">
                    <span v-if="scope.row.picture==''||scope.row.picture==null" >  </span>
                    <span v-else >
                        <el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="scope.row.srcList">  </el-image>
                    </span>
                </template>
            </el-table-column>
			<el-table-column  prop="remark" label="描述信息" ></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
					<table-delete-button  @select-type="handleDel(scope.$index, scope.row)"  v-if="type==0"></table-delete-button>
				</template>
			</el-table-column>
        </el-table>

        <el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[20,50,100,200]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

        <el-dialog :title="titleType" :visible.sync="dialogRecordVisible"  :append-to-body="true"  width="50%">
        	<el-form :model="formUserDevops" label-width="100px" :rules="formRules" ref="formUserDevops">
                <el-form-item label="项目名称"  prop="projectId" v-if="titleType=='新增'">
					<el-select v-model="formUserDevops.projectId" @change="getDevicesForm" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称"  v-if="type==1&&titleType=='新增'"  prop="deviceId" >
					<el-select v-model="formUserDevops.deviceid" filterable>
						<el-option
							v-for="item in devicesFrom"
							:label="item.Name"
							:value="item.DeviceId" :key="item.DeviceId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="点位编码"  v-if="type==0&&titleType=='新增'"  prop="deviceId">
					<el-select v-model="formUserDevops.deviceid" filterable>
						<el-option
							v-for="item in devicesFrom"
							:label="item.MnCode"
							:value="item.DeviceId" :key="item.DeviceId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="校准日期" prop="time">
					<el-date-picker v-model="formUserDevops.time" align="right" type="date" format="yyyy-MM-dd"	value-format="yyyy-MM-dd"> </el-date-picker>
				</el-form-item>
                <el-form-item label="有效期至" prop="expiration">
					<el-date-picker v-model="formUserDevops.expiration" align="right" type="date" format="yyyy-MM-dd"  	value-format="yyyy-MM-dd"> </el-date-picker>
				</el-form-item>

                <el-form-item label="送检证书" prop="picture">
					<el-upload class="upload-demo" action="#" :http-request="httpRequest" ref="upload" name="file" :on-change="change" :on-remove="remove"
					 accept="image/*"  :file-list="fileListShow"  list-type="picture" multiple :auto-upload="false">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传图片文件，且最好不超过500kb</div>
					</el-upload>
				</el-form-item>
                 <el-form-item label="描述信息" prop="remark">
					<el-input v-model="formUserDevops.remark" ></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" >提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,selectDeviceInspectionRecord,addDeviceInspectionRecord,
		updateDeviceInspectionRecord,deleteDeviceInspectionRecord} from '../../api/api';
    import {formatDateDay} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import TableDeleteButton from '../../components/myButton/TableDeleteButton.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
		components: { myButton,TableUpdateButton,TableDeleteButton },
		data() {
			return {
				filters: {
					projectId:"",
					deviceId:""
				},
				time:[],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				listLoading: false,
				firstFlag:true,
				devices:[],
                devicesFrom:[],
				projects:[],
				formHeight:0,
                total: 0,
               	page:1,
				pageSize:50,

				type:sessionStorage.getItem("type"),

				userId:sessionStorage.getItem('userId'),

                maintenanceRecordList:[  ],
                formRules:{
                    time: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    expiration: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
					projectId: [
						{ required: true, message: '必选', trigger: 'change' }
					],
                    deviceid: [
						{ required: true, message: '必选', trigger: 'change' }
					],
					picture: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                },
                dialogRecordVisible:false,
                formUserDevops:{
                    projectId:"",
					deviceid:"",
                    time:"",
                    expiration:"",
                    remark:""
                },
                fileList: [],
				fileListShow:[],
				removeFileId:[],
				length:0,
				firstFlag:true,
				titleType:''
			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.selectDeviceInspectionRecord();
				}else if(type=="add"){
					this.showAdd();
				}else if(type=="reset"){
					this.reset();
				}
			},
            handleCurrentChange(val) {
				this.page=val;
				this.selectDeviceInspectionRecord();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.selectDeviceInspectionRecord();
			},
            remove:function(file, fileList){
				if(file.name==undefined){
					var i=0;
					this.fileList.forEach(element => {
						if(element.uid==file.uid){
							this.fileList.splice(i, 1);
							return;
						}
						i++;
					});
				}else{
					this.removeFileId.push(file.name);
				}
			},
			change:function(file, fileList){
				//判断上传文件数量
				this.length=document.querySelector("input[type=file]").files.length;
				if(this.length>0){
					Array.from(document.querySelector("input[type=file]").files).forEach(file=>{
						if(this.fileList.indexOf(file) == -1){
							this.fileList.push(file);
						}
					})
				}
				return false;
			},
			httpRequest(){},
            cancleSubmit(){
                this.dialogRecordVisible=false;
            },
            submitData:function(){
				if(this.titleType=='修改'){
                   this.editSubmit();
                }else{
					this.addSubmit();
                }
			},
			addSubmit(){
				this.$refs.formUserDevops.validate((valid) => {
					if (valid) {
						if(this.fileList.length==0){
							this.$message({
								message: "请上传送检证书图片再提交",
								type: 'error'
							})
							return;
						}
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							let formData = new FormData();
							var i=0;
							this.fileList.forEach(file=> {
								formData.append("files"+i, file);
								i++;
							});

							formData.append("deviceid",this.formUserDevops.deviceid);
                            formData.append("time",this.formUserDevops.time);
                            formData.append("expiration",this.formUserDevops.expiration);
							formData.append("remark",this.formUserDevops.remark);

							this.listLoading = true;
							addDeviceInspectionRecord(formData).then((res) => {
								this.listLoading = false;
								if (res.data == true||res.data == "true") {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: "数据操作失败，请重试",
										type: 'error'
									})
									return;
								}
								this.fileListShow=[];
								this.removeFileId=[];
								this.dialogRecordVisible = false;
								this.selectDeviceInspectionRecord();
							}).catch(error => {
								this.listLoading = false;
								this.$message({
									message: "数据操作失败，可能是文件过大",
									type: 'error'
								})
								return;
							});
						});
					}
				});
			},
			editSubmit(){
				this.$refs.formUserDevops.validate((valid) => {
					if (valid) {
						if(this.fileList.length+this.formUserDevops.srcList.length<=this.removeFileId.length){
							this.$message({
								message: "请上传送检证书图片再提交",
								type: 'error'
							})
							return;
						}

						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							let formData = new FormData();
							var i=0;
							this.fileList.forEach(file=> {
								formData.append("files"+i, file);
								i++;
							});

							formData.append("picture",this.formUserDevops.picture);
							formData.append("removeFileId",this.removeFileId.toString());
							formData.append("id",this.formUserDevops.id);
							formData.append("remark",this.formUserDevops.remark);
							formData.append("time",this.formUserDevops.time);
                            formData.append("expiration",this.formUserDevops.expiration);

							this.listLoading = true;
							updateDeviceInspectionRecord(formData).then((res) => {
								this.listLoading = false;
								if (res.data == true||res.data == "true") {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: "数据操作失败，请重试",
										type: 'error'
									})
									return;
								}
								
								this.fileListShow=[];
								this.removeFileId=[];
								this.dialogRecordVisible = false;
								this.selectDeviceInspectionRecord();
							}).catch(error => {
								this.listLoading = false;
								this.$message({
									message: "数据操作失败，可能是文件过大",
									type: 'error'
								})
								return;
							});
						});
					}
				});
			},
            showAdd(){
                this.formUserDevops={
					picture: '11',
					projectId:"",
					deviceid:"",
                    time:"",
                    expiration:"",
                    remark:""
				};
                this.fileListShow=[];
				this.removeFileId=[];
				this.fileList=[];
                this.dialogRecordVisible=true;
                if( this.$refs.formUserDevops!=undefined){
               		this.$refs.formUserDevops.resetFields();
				}
				this.titleType="新增";
            },
			//显示修改界面
			handleEdit: function (index, row) {
				this.removeFileId=[];
				this.fileList=[];
				this.dialogRecordVisible = true;
				if( this.$refs.formUserDevops!=undefined){
               		this.$refs.formUserDevops.resetFields();
				}
				this.titleType='修改';

				this.fileListShow=[];
				if(row.picture!=null&&row.picture!=""){
					var imgarr=row.picture.split(';');
					for(var j=0;j<imgarr.length;j++){
						if(imgarr[j]==""){
							continue;
						}
						var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
						var obj={
							url:url,
							name:imgarr[j]
						}
						this.fileListShow.push(obj);
					}
				}else{
					row.picture="";
				}
				this.formUserDevops = Object.assign({}, row);
			},
			//显示删除界面
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let formData = new FormData();
					formData.append("id", row.id.toString());
					deleteDeviceInspectionRecord(formData).then((res) => {
						this.listLoading = false;
						let resData = res.data;
						if (resData == true||resData == "true") {
							this.$message({
								message: '删除成功',
								type: 'success'
						})}else{
							this.$message({
								message: "删除失败",
								type: 'error'
							});
						}
						this.selectDeviceInspectionRecord();
					});
				}).catch(() => {

				});
			},
            selectDeviceInspectionRecord(i,row){
				let para = Object.assign({}, this.filters);
                para.page= this.page;
                para.limit=this.pageSize;

                var starttime='';
                var endtime='';
                if(this.time!=null&&this.time.length>0){
                    starttime=this.time[0];
					endtime=this.time[1];
                }
                para.startDate=starttime;
                para.endDate=endtime;
				para.userId=this.userId;
                selectDeviceInspectionRecord(para).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
                    this.total = res.data.total;
					this.maintenanceRecordList = res.data.data;
					this.maintenanceRecordList.forEach(element => {
                        var arr=[];
						if(element.picture!=""&&element.picture!=null){
							var imgarr=element.picture.split(';');
							for(var j=0;j<imgarr.length;j++){
								if(imgarr[j]==""){
									continue;
								}
								var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
								arr.push(url);
							}
							element.srcList=arr;
						}
					});
				});
			},
			reset(){
                this.filters.deviceId="";
				this.time=[];
				this.selectDeviceInspectionRecord();
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
					if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
                    if(this.firstFlag){
						this.firstFlag=false;
						this.selectDeviceInspectionRecord();
					}
				});
            },
			//获取设备列表
			getDevicesForm() {
                  let para = {
					projectId: this.formUserDevops.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devicesFrom = res.data;
                    this.formUserDevops.deviceId="";
				});
            },
			setTime(){
				var start = new Date();
				start.setTime(start.setMonth(start.getMonth()-1));
				var end = new Date();
				this.time= [formatDateDay(start), formatDateDay(end)];
			},
            SetHeight:function(){
                var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-100;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getProjects();
			this.setTime();
		}, 
	}

</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// DeviceInspectionRecord.vue?d2b09246